import { apiClient } from './apiService';

class DropInService {
  setAuthToken(_token) {}   // auth handled by cookie via apiClient

  async list(params = {}) {
    const query = new URLSearchParams();
    if (params.status)     query.set('status',      params.status);
    if (params.sport_id)   query.set('sport_id',    params.sport_id);
    if (params.sport_ids)  query.set('sport_ids',   params.sport_ids);
    if (params.skill_level) query.set('skill_level', params.skill_level);
    // "Near me": both coordinates or neither; radius is in metres
    if (params.lat != null && params.lng != null) {
      query.set('lat', params.lat);
      query.set('lng', params.lng);
      if (params.radius) query.set('radius', params.radius);
    }
    if (params.limit)      query.set('limit',       params.limit);
    if (params.offset)     query.set('offset',      params.offset);
    if (params.include_past) query.set('include_past', 'true');
    const qs = query.toString();
    const response = await apiClient.get(`/drop-in${qs ? `?${qs}` : ''}`);
    return response.data;
  }

  async myDropIns() {
    const response = await apiClient.get('/drop-in/my');
    return response.data;
  }

  async getById(id) {
    const response = await apiClient.get(`/drop-in/${id}`);
    return response.data;
  }

  async create(data) {
    const response = await apiClient.post('/drop-in', data);
    return response.data;
  }

  async update(id, data) {
    const response = await apiClient.put(`/drop-in/${id}`, data);
    return response.data;
  }

  async cancel(id) {
    const response = await apiClient.delete(`/drop-in/${id}`);
    return response.data;
  }

  // Status moves through start / complete / cancel, not an edit (DI-B10)
  async start(id) {
    const response = await apiClient.post(`/drop-in/${id}/start`);
    return response.data;
  }

  async complete(id) {
    const response = await apiClient.post(`/drop-in/${id}/complete`);
    return response.data;
  }

  async join(id) {
    const response = await apiClient.post(`/drop-in/${id}/join`);
    return response.data;
  }

  /** Pay for a seat held unpaid. Returns { data: { status: 'payment_required', checkoutUrl, paymentId } } */
  async pay(id) {
    const response = await apiClient.post(`/drop-in/${id}/pay`);
    return response.data;
  }

    async leave(id) {
    const response = await apiClient.post(`/drop-in/${id}/leave`);
    return response.data;
  }

  async checkIn(dropInId, playerId) {
    const response = await apiClient.post(`/drop-in/${dropInId}/check-in`, { player_id: playerId });
    return response.data;
  }

  async generateTeams(dropInId, numTeams = 2) {
    const response = await apiClient.post(`/drop-in/${dropInId}/generate-teams`, { num_teams: numTeams });
    return response.data;
  }

  async invitePlayer(dropInId, userId) {
    const response = await apiClient.post(`/drop-in/${dropInId}/invite`, { user_id: userId });
    return response.data;
  }

  async acceptInvite(dropInId) {
    const response = await apiClient.post(`/drop-in/${dropInId}/accept-invite`);
    return response.data;
  }

  async rejectInvite(dropInId) {
    const response = await apiClient.post(`/drop-in/${dropInId}/reject-invite`);
    return response.data;
  }

  async removePlayer(dropInId, userId) {
    const response = await apiClient.delete(`/drop-in/${dropInId}/players/${userId}`);
    return response.data;
  }

  async searchUsersForInvite(dropInId, query) {
    const response = await apiClient.get(`/drop-in/${dropInId}/invite-search?q=${encodeURIComponent(query)}`);
    return response.data;
  }

  async createMatch(dropInId, data) {
    const response = await apiClient.post(`/drop-in/${dropInId}/matches`, data);
    return response.data;
  }

  async getMatches(dropInId) {
    const response = await apiClient.get(`/drop-in/${dropInId}/matches`);
    return response.data;
  }

  // ── Messages ──────────────────────────────────────────────────────────────
  async getMessages(dropInId) {
    const response = await apiClient.get(`/drop-in/${dropInId}/messages`);
    return response.data;
  }

  async sendMessage(dropInId, message, messageType = 'message') {
    const response = await apiClient.post(`/drop-in/${dropInId}/messages`, { message, message_type: messageType });
    return response.data;
  }

  // ── Permanent members ─────────────────────────────────────────────────────
  async getMembers(dropInId) {
    const response = await apiClient.get(`/drop-in/${dropInId}/members`);
    return response.data;
  }

  async addMember(dropInId, userId) {
    const response = await apiClient.post(`/drop-in/${dropInId}/members`, { user_id: userId });
    return response.data;
  }

  async removeMember(dropInId, userId) {
    const response = await apiClient.delete(`/drop-in/${dropInId}/members/${userId}`);
    return response.data;
  }

  // ── Recurring: open this week's session ──────────────────────────────────
  async openWeeklySession(dropInId, overrides = {}) {
    const response = await apiClient.post(`/drop-in/${dropInId}/open-week`, overrides);
    return response.data;
  }

  handleError(error) {
    const msg = error?.response?.data?.message || error?.message || 'Unexpected error';
    throw new Error(msg);
  }
}

const dropInService = new DropInService();
export default dropInService;
